export const types = {
  UPDATE_AUDIO_TIME: 'UPDATE_AUDIO_TIME',
  PLAY_AUDIO: 'PLAY_AUDIO',
  PAUSE_AUDIO: 'PAUSE_AUDIO',
  SET_LOADING: 'SET_LOADING'
}

export const play = src => {
  return (dispatch) => {
    dispatch({
      type: types.PLAY_AUDIO,
      src
    })
  }
}
export const pause = () => {
  return (dispatch) => {
    dispatch({
      type: types.PAUSE_AUDIO,
    })
  }
}
export const updateTime = time => {
  return (dispatch) => {
    dispatch({
      type: types.UPDATE_AUDIO_TIME,
      time
    })
  }
}
export const setLoading = state => {
  return (dispatch) => {
    dispatch({
      type: types.SET_LOADING,
      state
    })
  }
}